/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzsmedizin10Inputs */

const en__field_enum_mzsmedizin10 = /** @type {(inputs: _Field_Enum_Mzsmedizin10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`medicine`)
};

const de__field_enum_mzsmedizin10 = /** @type {(inputs: _Field_Enum_Mzsmedizin10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medizin`)
};

/**
* | output |
* | --- |
* | "medicine" |
*
* @param {_Field_Enum_Mzsmedizin10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzsmedizin10 = /** @type {((inputs?: _Field_Enum_Mzsmedizin10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzsmedizin10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzsmedizin10(inputs)
	return de__field_enum_mzsmedizin10(inputs)
});
export { _field_enum_mzsmedizin10 as "_field_enum_MZSMEDIZIN" }